import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:7000/api",
    // baseURL: "https://be.sadaatpoultryservices.com/api",
    baseURL: "https://be-erp.reyssolutions.com/api",
});
